var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formType.code === 'MPSC')?_c('div',[_c('FormPregrado')],1):_c('div',[(_vm.formType.code === 'MS')?_c('div',[_c('FormSecundario')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }